import borders from "../../base/borders";

const {borderRadius} = borders;

const accordion: any = {
    baseStyle: {
        borderWidth: 1,
        borderRadius: 'md',
        borderColor: 'gray.300',
        overflow: 'hidden',
    },
    defaultProps: {
        variant: 'outline',
    },

    styleOverrides: {
        root: {
            boxShadow: "0px 2px 4px 0px #00000040",

            "&:first-of-type": {
                borderTopLeftRadius: borderRadius.md,
                borderTopRightRadius: borderRadius.md
            },

            "&:last-of-type": {
                borderBottomLeftRadius: borderRadius.md,
                borderBottomRightRadius: borderRadius.md
            }
        },


    }
}

export default accordion
